import React from 'react';
import {useNavigate} from 'react-router-dom';
import BaseGenerateDocumentButton from './BaseGenerateDocumentButton';
import { logEvent } from '../../analytics';


export default function GenerateDocumentAndRedirectButton({patient, onGenerateClicked}) {
  const navigate = useNavigate();

  const handleDocumentCreated = () => {
    logEvent('SessionDetails', 'GenerateDocument');
    navigate(`/patients/${patient.getUUID()}?generating=1`);
  };

  return (
    <BaseGenerateDocumentButton
      patient={patient}
      onGenerateClicked={onGenerateClicked}
      onDocumentCreated={handleDocumentCreated}
    />
  );
} 